// oxlint-disable no-console
/**
 * Logger module
 * @author Olive
 */

const baseStyle = `
  padding: 2px 4px;
  border-radius: 2px;
  font-weight: bold;
  font-family: 'SUIT';
`;

const styles = {
  info: `color: white; background: #2196f3; ${baseStyle}`, // 파란색
  warn: `color: black; background: #ffeb3b; ${baseStyle}`, // 노란색
  error: `color: white; background: #f44336; ${baseStyle}`, // 빨간색
  debug: `color: white; background: #9e9e9e; ${baseStyle}`, // 회색
};

/**
 * logger module
 * info/warn/error/debug 레벨에 따라서 사용 가능 (e.g. logger.info('hello');)
 * @author Olive
 */
const logger = {
  info: (...args: any[]) => {
    console.info('%c[virtual][INFO]', styles.info, ...args);
  },
  warn: (...args: any[]) => {
    console.warn('%c[virtual][WARN]', styles.warn, ...args);
  },
  error: (...args: any[]) => {
    console.error('%c[virtual][ERROR]', styles.error, ...args);
  },
  debug: (...args: any[]) => {
    console.debug('%c[virtual][DEBUG]', styles.debug, ...args);
  },
};

export default logger;
